'use strict';
module.exports = /*@ngInject*/ ["ObjectDiff",
 function (ObjectDiff) {
    return {
        restrict: 'E',
        scope: {
            left: '<',
            right : '<',
            ignoreFields: '<'
        },
        template: [
            `<pre ng-bind-html="diffValueChanges | toJsonDiffView" ></pre>
           `
        ].join(''),

        link: function (scope,  el, attr) {   
            
            scope.diffValueChanges = ObjectDiff.diff(
                _removeExtraProperties(Object.assign({}, scope.left), scope.ignoreFields), 
                _removeExtraProperties(Object.assign({}, scope.right), scope.ignoreFields))
            scope.$digest();

            function _removeExtraProperties(jsonObject, ignoreFields) {
                if (ignoreFields && ignoreFields.length > 0 && Object.keys(jsonObject).length > 0) {
                    for (let index = 0; index < ignoreFields.length; index++) {
                        delete jsonObject[ignoreFields[index]];   
                    }
                }
                return jsonObject;
            }
        }
    };
}];
